export const MULTISEARCH_OPERATIONS = '@multisearch/MULTISEARCH_OPERATIONS';
export const MULTISEARCH_OPERATIONS_ERROR = '@multisearch/MULTISEARCH_OPERATIONS_ERROR';
export const MULTISEARCH_OPERATIONS_LOADING = '@multisearch/MULTISEARCH_OPERATIONS_LOADING';
export const MULTISEARCH_OPERATIONS_SUCCESS = '@multisearch/MULTISEARCH_OPERATIONS_SUCCESS';